// App Configuration - Easy to customize for production
export const APP_CONFIG = {
  // App Details
  APP_NAME: "PXL App",
  APP_DESCRIPTION: "Mine coins and invite friends",

  // Primary Coin Configuration
  PRIMARY_COIN_NAME: "PXLS",
  PRIMARY_COIN_SYMBOL: "PXLS",
  PRIMARY_COIN_IMAGE_PATH: "/assets/images/aec.png", // Path to the primary coin image

  // Secondary Coin Configuration
  SECONDARY_COIN_NAME: "SHIBA INU",
  SECONDARY_COIN_SYMBOL: "SHIBA",
  SECONDARY_COIN_IMAGE_PATH: "/assets/images/shiba.png", // Path to the secondary coin image
  SECONDARY_COIN_USD_PRICE: 0.175, // Price of one secondary coin in USD

  // Bot Configuration - Change this when selling the project
  BOT_USERNAME: "PixelMinersbot", // Your bot username without @
  BOT_APP_URL: "https://t.me/PixelMinersbot/app", // Direct Mini App URL,

  // Security Configuration (Recommended)
    BLOCK_OUTSIDE_TELEGRAM: false, // Block access if not in Telegram 
    BLOCK_ON_DESKTOP: false, // Block access on desktop devices

  // Gameplay Configuration
  MINIMUM_CLAIM_AMOUNT: 100, // Minimum amount of secondary coin required to claim
  MINIMUM_WITHDRAWAL_AMOUNT_SECONDARY_COIN: 1000, // Minimum amount for secondary coin withdrawal
  MINER_POWER: 1.0, // Default mining power (coins per second)

  // Referral Configuration
  REFERRAL_BONUS: 1000, // Reward for both referrer and referred user
  REFERRAL_REWARD_AMOUNT: 1000, // Alias for easier access
  REFERRAL_CODE_PREFIX: "", // No prefix - use Telegram ID directly

  // Sharing Configuration
  SHARE_MESSAGE: "🎮 Join me in our app and start mining crypto! 💰\n\n🎁 Use my referral link to get a bonus!\n\n👇 Click here to start:",

  // Social Media Configuration
  TELEGRAM_SHARE_URL: "https://t.me/share/url",

  // Booster/CPU Configuration - Easy to customize
  BOOSTER_CONFIG: {
    // Global defaults
    RENT_PRICE: 0, // Default rent price
    RENT_PERIOD_DAYS: 30, // Default rent period

    // Individual CPU settings
    CPUS: {
      GREEN: {
        ID: "green",
        NAME: "Green CPU",
        IMAGE_PATH: "/assets/images/greenCPU.png", // Don't change image paths
        DAILY_PROFIT: 99.33312,
        TOTAL_PROFIT: 2700.9936,
        RENT_PERIOD_DAYS: 30,
        RENT_PRICE: 20000,
      },
      BLUE: {
        ID: "blue",
        NAME: "Blue CPU",
        IMAGE_PATH: "/assets/images/blueCPU.png", // Don't change image paths
        DAILY_PROFIT: 66.66624,
        TOTAL_PROFIT: 1800.9872,
        RENT_PERIOD_DAYS: 30,
        RENT_PRICE: 20000,
      },
      YELLOW: {
        ID: "yellow",
        NAME: "Yellow CPU",
        IMAGE_PATH: "/assets/images/yellowCPU.png", // Don't change image paths
        DAILY_PROFIT: 133.33248,
        TOTAL_PROFIT: 3999.9744,
        RENT_PERIOD_DAYS: 30,
        RENT_PRICE: 30000,
      },
    },
  },

  // Generate referral URL
  generateReferralUrl: (referralCode) => {
    return `${APP_CONFIG.BOT_APP_URL}?startapp=${referralCode}`;
  },

  // Generate Telegram share URL
  generateTelegramShareUrl: (referralCode) => {
    const referralUrl = APP_CONFIG.generateReferralUrl(referralCode);
    const message = encodeURIComponent(
      `${APP_CONFIG.SHARE_MESSAGE}\n\n${referralUrl}`
    );
    return `${APP_CONFIG.TELEGRAM_SHARE_URL}?url=${encodeURIComponent(
      referralUrl
    )}&text=${message}`;
  },
};

// Helper function to generate unique referral code (simplified - just use Telegram ID)
export const generateReferralCode = (userId) => {
  return userId.toString();
};

export default APP_CONFIG;

